import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';

@Component({
  selector: 'app-campaign-action-choice',
  templateUrl: './campaign-action-setup.component.html',
  styleUrls: ['./campaign-action-setup.component.css', '../coupon-setup.scss']
})
export class CampaignActionSetupComponent implements OnInit {
  campaignId: string;
  campaignName: string;
  actions: any[];
  button: boolean;
  actionTypeId: number;

  constructor(
    private campaignService: Campaign2Service,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.campaignId = this.activatedRoute.snapshot.params['campaignId'];
    this.campaignName = this.activatedRoute.snapshot.paramMap.get('campaignName');
    this.campaignService.getActionTypeList().subscribe(
      res => {
        this.actions = res;
      }
    );
  }

  viewButton(actionTypeId: number) {
    this.actionTypeId = actionTypeId;
    this.button = true;
  }

  goToEmission(actionType?: any) {
    this.actionTypeId = actionType.id;
    this.router.navigate([`campaign-coupon-emission-setup/${this.campaignId}`, {
      actionTypeId: actionType.id,
      actionTypeCode: actionType.code
    }]);
  }

  goBack(){
    this.router.navigate([`campaign-list-2`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-action-setup/campaign-action-setup.component.ts